interface AppRoute {
  PREMIUM_VOUCHER: {
    ROOT: string;
    SUCCESS_NOTIFICATION: string;
    RELEASE: string;
    HISTORY_LOTTERY: string;
    WHAT_IS: string;
    LIST_VOUCHER: string;
    VOUCHER_DETAIL: string;
    PAYMENT: string;
    BANK_TRANSFER_INFO: string;
    BANK_TRANSFER_RESULT: string;
    PAYMENT_SUCCESS: string;
    PAYMENT_FAILED: string;
    CVS_REDIRECT: string;
    CVS_CALLBACK: string;
    SEARCH: string;
    POST_CODE: string;
    INFO_MEMBER: string;
    TOP: string;
    HISTORY: string;
    USE_HISTORY: string;
    HISTORY_DETAIL: string;
    HISTORY_USE_DETAIL: string;
    HISTORY_LOTTERY_DETAIL: string;
    SUCCESSFUL_USE: string;
    QA: string;
    LOGIN: string;
    REGISTER: string;
    LIST_STORES: string;
    CHECK_LOTTERY: string;
    TERMS: string;
    NOTIFICATIONS: string;
    LOTTERY_VOUCHER_NOTICE: string;
    BUY_VOUCHER: string;
    RESET_PASSWORD: string;
    FONT_SIZE_SETTING: string;
    MY_NUMBER_CALLBACK: string;
  };

  NOT_FOUND: string;
}

export const appRoutes: AppRoute = {
  PREMIUM_VOUCHER: {
    ROOT: "premium-voucher",
    SUCCESS_NOTIFICATION: "success-notification",
    RELEASE: "release", //list coupon bought
    HISTORY_LOTTERY: "history-lottery", //list lottery coupon bought
    WHAT_IS: "what-is",
    LIST_VOUCHER: "list",
    VOUCHER_DETAIL: "detail", // coupon can buy detail
    PAYMENT: "payment",
    BANK_TRANSFER_INFO: "bank-transfer-info",
    BANK_TRANSFER_RESULT: "bank-transfer-result",
    PAYMENT_SUCCESS: "payment-success",
    PAYMENT_FAILED: "payment-failed",
    CVS_REDIRECT: "cvs-redirect",
    CVS_CALLBACK: "cvs-callback",
    SEARCH: "search-coupon", // coupon detail
    POST_CODE: "post-code",
    INFO_MEMBER: "info-member",
    TOP: "top",
    HISTORY: "history",
    USE_HISTORY: "use-history",
    HISTORY_DETAIL: "history-detail",
    HISTORY_USE_DETAIL: "history-use-detail",
    HISTORY_LOTTERY_DETAIL: "history-lottery-detail",
    SUCCESSFUL_USE: "successful-use",
    QA: "qa",
    LOGIN: "login",
    REGISTER: "register",
    LIST_STORES: "list-stores",
    CHECK_LOTTERY: "check-lottery",
    TERMS: "terms",
    NOTIFICATIONS: "notifications",
    LOTTERY_VOUCHER_NOTICE: "lottery-voucher-notice",
    BUY_VOUCHER: "buy-voucher",
    RESET_PASSWORD: "reset-password",
    FONT_SIZE_SETTING: "font-size",
    MY_NUMBER_CALLBACK: "mynumber/callback"
  },

  NOT_FOUND: "404",
};
